module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jessie Haas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jessie Haas is the author of numerous acclaimed books for young people, including "), _c('I', [_vm._v("Unbroken")]), _vm._v(", which was a Publishers Weekly Best Book. She lives in Westminster, Vermont, with her husband, Michael J. Daley, a children’s author. Haas began writing about horses from a young age and wrote a story during her junior year of college that became her first novel, "), _c('I', [_vm._v("Keeping Barney")]), _vm._v(". "), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/JaAyVK/tc-custom/9781497662667.jpg?1705490463819",
      "alt": "This image is the cover for the book Beware and Stogie, Beware the Mare"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Beware and Stogie, Beware the Mare\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An untamed horse has run away—can Lily and Beware find him and bring him home? ")]), _c('br'), _c('br'), _vm._v("After a storm scatters all the livestock on her grandparents’ farm, Lily discovers that Gramp’s wild black Morgan is missing. Stogie’s a horse with a mind of his own, and when he runs, no one can ever catch him."), _c('br'), _vm._v(" "), _c('br'), _vm._v("Stogie may be boss of the other animals on the farm, but he’s afraid of people. And a frightened horse is a dangerous one. Lily’s determined to find the black Morgan and bring him home before he ends up getting hurt—or shot. Since no one can catch Stogie, no one can lead him. But Lily brings a rope anyway. As she and Beware set off on their search, she tries to put herself in Stogie’s shoes to figure out where he would go. Then she gets an idea . . ."), _c('br'), _vm._v(" "), _c('br'), _vm._v("Can she and Beware find and catch Stogie before it’s too late? "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0